import {MutationTree} from 'vuex';
import {BackendData} from './types';

export const mutations: MutationTree<BackendData> = {

    setData(state, payload) {
        state.allData = Object.assign({}, state.allData, payload);
    },
};
